export const enum ETranscoderProfileType {
  cloned = 'cloned',
  default = 'default',
  new = 'new',
  shared = 'shared',
}

export const enum ETranscoderSelectValueType {
  string = 'string',
  number = 'number',
}

export const enum ETranscoderTaskControlAction {
  start = 'start',
  stop = 'stop',
  forceStop = 'forceStop',
}

export const enum ETranscoderTaskStatus {
  startFailed = 'startFailed',
  stopped = 'stopped',
  starting = 'starting',
  running = 'running',
  stopping = 'stopping',
  failed = 'failed',
  queued = 'queued',
  completed = 'completed',
  runningWithIssues = 'runningwithissues',
}

export enum ETranscoderState {
  idle = 'idle',
  starting = 'starting',
  started = 'started',
  waiting = 'waiting',
  probing = 'probing',
  running = 'running',
  stopping = 'stopping',
  stopped = 'stopped',
  completed = 'completed',
  readytostart = 'readytostart',
  failed = 'failed',
  restarting = 'restarting',
}

export const enum ETranscoderOutputFormat {
  mp4 = 'mp4',
  mpegts = 'mpegts',
}

export const enum ETranscoderProfileKind {
  audio = 'audio',
  video = 'video',
}

export enum TranscoderWorkerType {
  HD_ABR = 'worker-hd-abr',
  HD_Single = 'worker-hd-single',
  SD_ABR = 'worker-sd-abr',
  SD_Single = 'worker-sd-single',
  All_In_One = '',
}
